import { Outside } from '@cian/ui-kit';
import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './PopupModal.css';
import { PopupPortal } from '../PopupPortal';
import { ClosePopupIcon } from '../common/icons';

export interface IPopupModalProps {
  className?: IStyleConfig;
  children: React.ReactNode;
  onClose(): void;
}

export function PopupModal({ onClose, className, children }: IPopupModalProps) {
  return (
    <PopupPortal containerStyle={styles['container']}>
      <Outside onOutside={onClose}>
        <div {...mergeStyles(styles['modal'], className)}>
          <div className={styles['header']}>
            <button className={styles['close_button']} onClick={onClose}>
              <ClosePopupIcon />
            </button>
          </div>
          {children}
        </div>
      </Outside>
    </PopupPortal>
  );
}
